import CreateReducer from '../../misc/CreateReducer';
import {ActionTypes} from '../ActionTypes';

export const paymentTemplate = CreateReducer(
  {
    isLoading: false,
    data: null,
    message: null,
    failed: false,
  },
  {
    [ActionTypes.GET_TEMPLATE_REQUEST]: (state, action) => {
      return Object.assign({}, state, action);
    },
    [ActionTypes.GET_TEMPLATE_SUCCESS]: (state, action) => {
      return Object.assign({}, state, action);
    },
    [ActionTypes.GET_TEMPLATE_FAILURE]: (state, action) => {
      return Object.assign({}, state, action);
    },
  },
  true,
);
